var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-06-07
 * @brief SEI 체크시트 Management 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reLoadState, userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useAsync } from "react-async";
import { Trans } from "react-i18next";
import { alertState } from "../../../recoil/assessmentState";
import { checkListInfo, checkSheetInfo, checkSheetState, loadingBoxState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
import EhpPagination from "../../common/pagination/EhpPagination";
function CheckSheetList(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [sheetInfo, setSheetInfo] = useRecoilState(checkSheetInfo);
    const setListInfo = useSetRecoilState(checkListInfo);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const setReload = useSetRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //props
    const { handleOpenPop, checksheetName, WorkModes } = props;
    //
    const itemAgeList = [
        { name: "All", value: "all" },
        { name: "Condition", value: "con" },
        { name: "Degredation", value: "deg" },
    ];
    const [errorList, setErrorList] = useState([]);
    const [popType, setPopType] = useState("");
    const [popReset, setPopReset] = useState(false);
    const [sheetItem, setSheetItem] = useState([]);
    const [versionItem, setVersionItem] = useState([]);
    const [guideItem, setGuideItem] = useState(null);
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    let appPath = `?checkversionId=${sheetInfo.checkversionId}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // 정렬
    if (sortData.sortField.length > 0) {
        appPath = appPath + "&sort=" + sortData.sortField + "," + sortData.sort;
    }
    // //checksheet Tree
    // // 검색 필드
    // if (searchTextField.searchText.length > 0) {
    //   appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    // }
    useEffect(() => {
        //가이드
        handleOpenPop("pop-guide", _jsx(GuidePop, { popReset: popReset, setPopReset: setPopReset, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close ", onClick: (e) => Close("pop-guide") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        // 등록
        handleOpenPop("pop-g-add", _jsx(CheckSheetPop, { popType: popType, popReset: popReset, setPopReset: setPopReset, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close ", onClick: (e) => Close("pop-g-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
        // 버전삭제
        handleOpenPop("pop-check-close", _jsx(VerDeletePop, { WorkModes: WorkModes }));
    }, [popType, popReset, errorList]);
    function Close(id) {
        setPopReset(true);
        CUTIL.jsclose_Popup(id);
    }
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checkitems${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadState + sheetInfo.enabled,
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSheetItem(data.body);
                setPageInfo(Object.assign({}, data.data.page /* psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false  */)); //5, 10; //5, 10
            }
        }
    }, [data]);
    // 버젼 선택
    function VerionNoList(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            // 상세 유형 초기화
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/checksubtype/${sheetInfo.checkSubTypeId}/checkversions`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setVersionItem(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 버젼 선택 시
    function VersionClick(item) {
        setSheetInfo(Object.assign(Object.assign({}, sheetInfo), { checkversionId: item.checkVersionId, versionNo: item.versionNo, enabled: item.enabled }));
        handleCurPage(0);
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    //뒤로가기
    function CheckSheetView(e) {
        WorkModes("VIEW");
    }
    // 버젼 수정
    function CheckSheetPut(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/checksheet/checktype/checksubtype/checkversion/copy`,
                appQuery: {
                    versionIdCopiedFrom: sheetInfo.checkversionId,
                    companyId: checksheet.sheetType == checksheetName[0] ? null : sheetInfo.companyId,
                    spgName: checksheet.spgName,
                    checktypeName: checksheet.sheetType,
                    checkSubtypeName: sheetInfo.checkSubTypeName,
                    description: sheetInfo.description,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSheetInfo(Object.assign(Object.assign({}, sheetInfo), { checkversionId: data.body.checkversionId, versionNo: data.body.versionNo, enabled: data.body.enabled }));
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    function CheckSheetPopOpen(e, type, item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (type == "post" && e.currentTarget.nodeName == "BUTTON") {
                setPopType(type);
                CUTIL.jsopen_Popup(e);
            }
            else if (type == "delete" && e.target.nodeName == "BUTTON") {
                setListInfo({
                    checkGroup: {
                        groupId: item.checkGroup.groupId,
                        groupName: item.checkGroup.groupName,
                    },
                    checkItemId: item.checkItemId,
                    description: item.description,
                    instrument: item.instrument,
                    name: item.name,
                    type: item.type,
                    weight: item.weight,
                    checkItemRef: [],
                    itemAge: "",
                });
                CUTIL.jsopen_Popup(e);
            }
            else if (type == "getOrput" && e.target.nodeName !== "BUTTON") {
                setPopType(type);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checkitem/${item.checkItemId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setListInfo({
                            checkGroup: {
                                groupId: data.body.checkGroup.groupId,
                                groupName: data.body.checkGroup.groupName,
                            },
                            checkItemId: item.checkItemId,
                            description: data.body.description,
                            instrument: data.body.instrument,
                            name: data.body.name,
                            type: data.body.type,
                            weight: data.body.weight,
                            checkItemRef: data.body.checkItemRef,
                            itemAge: data.body.itemAge ? data.body.itemAge : "",
                        });
                        CUTIL.jsopen_AlertPopup("pop-g-add");
                    }
                }
            }
            else if (type == "guide" && e.target.nodeName == "BUTTON") {
                setListInfo({
                    checkGroup: {
                        groupId: item.checkGroup.groupId,
                        groupName: item.checkGroup.groupName,
                    },
                    checkItemId: item.checkItemId,
                    description: item.description,
                    instrument: item.instrument,
                    name: item.name,
                    type: item.type,
                    weight: item.weight,
                    checkItemRef: [],
                    itemAge: "",
                });
                CUTIL.jsopen_Popup(e);
            }
        });
    }
    // 버젼 완료
    function CheckSheetDone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checktype/checksubtype/checkversion/${sheetInfo.checkversionId}`,
                appQuery: {
                    checktypeName: checksheet.sheetType,
                    checkSubtypeName: sheetInfo.checkSubTypeName,
                    versionNo: sheetInfo.versionNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "작업 완료 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    WorkModes("VIEW");
                    setReload(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 체크시트 순서 위아래 변경
    function CheckSheetUpDown(item, clickSort) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checkitem/sort?checkItemId=${item.checkItemId}&direction=${clickSort}`,
                userToken: userInfo.loginInfo.token,
                watch: reLoadState,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "체크항목의 순서가 변경되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: sheetItem && (_jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top mt-19" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("button", Object.assign({ type: "button", className: "go-back tooltip-link", "data-tooltip": t("라벨.뒤로가기"), onClick: (e) => CheckSheetView(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB4A4\uB85C\uAC00\uAE30" })) })), _jsx("span", Object.assign({ className: "mr-16" }, { children: _jsx("strong", { children: t("라벨.상세유형") }) })), _jsxs("div", Object.assign({ className: "select w184" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: sheetInfo.checkSubTypeName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: _jsx("li", Object.assign({ className: "option" }, { children: "LS 7.2 " })) })] })), _jsx("span", Object.assign({ className: "mr-16 ml-48" }, { children: _jsx("strong", { children: t("라벨.버전") }) })), _jsxs("div", Object.assign({ className: "select w184", onClick: (e) => sheetInfo.enabled && VerionNoList(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsxs("div", Object.assign({ className: "selected-value" }, { children: [sheetInfo.versionNo, " ", !sheetInfo.enabled && `${t("라벨.버전")}`] })), " ", _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: versionItem &&
                                                        versionItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => VersionClick(item) }, { children: item.versionNo }), "checkVer_" + idx.toString()))) })] }))] })) })) })), _jsxs("div", Object.assign({ className: "right" }, { children: [!sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray js-open", "data-pop": "pop-g-add", onClick: (e) => CheckSheetPopOpen(e, "post", null) }, { children: _jsx("span", { children: t("라벨.점검항목추가") }) }))), !sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => CheckSheetDone(e) }, { children: _jsxs("span", { children: [t("라벨.작업완료"), "(", t("라벨.버전업데이트"), ")"] }) }))), sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray js-open", "data-pop": "pop-check-close", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsxs("span", { children: [t("라벨.버전삭제"), " "] }) }))), sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => CheckSheetPut(e) }, { children: _jsxs("span", { children: [t("라벨.버전수정"), " "] }) })))] }))] })), _jsx(Trans, Object.assign({ i18nKey: "체크시트관리.점검항목" }, { children: _jsxs("p", Object.assign({ className: "nodata__txt" }, { children: ["\uC810\uAC80\uD56D\uBAA9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4. ", _jsx("br", {}), " \uC6B0\uCE21 \uC0C1\uB2E8 '\uC810\uAC80\uD56D\uBAA9 \uCD94\uAC00' \uBC84\uD2BC\uC744 \uB20C\uB7EC \uB4F1\uB85D\uD574\uC8FC\uC138\uC694."] })) })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uADF8\uB8F9,\uC810\uAC80\uD56D\uBAA9,\uCE21\uC815\uC7A5\uBE44,\uC785\uB825\uBC29\uC2DD,\uAC00\uC911\uCE58,\uC810\uAC80\uAC00\uC774\uB4DC,\uCF54\uB4DC,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\"\uB77C\uBCA8.\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "29%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "10%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "groupName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("groupName") }, { children: _jsx("span", { children: t("라벨.그룹") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.점검항목") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.항목설명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.입력방식") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.가중치") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.점검가이드") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: t("라벨.삭제") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: t("라벨.항목순서변경") }) }))] }) }), _jsx("tbody", { children: sheetItem.map((item, idx) => (_jsxs("tr", Object.assign({ className: "js-open", "data-pop": "pop-g-add", onClick: (e) => CheckSheetPopOpen(e, "getOrput", item) }, { children: [_jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.checkGroup.groupName })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.name })) }), _jsx("td", { children: _jsxs("p", Object.assign({ className: "ellipsis" }, { children: [" ", item.instrument ? (_jsx("img", { src: require("/static/img/icon_gas.png"), alt: "", className: "list-icon" })) : (""), " ", item.description] })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.type == 1
                                                    ? t("라벨.점수선택")
                                                    : item.type == 2
                                                        ? t("라벨.측정값입력")
                                                        : t("라벨.측정값기록") })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.type == 3
                                                    ? "-"
                                                    : `${item.weight} (${item.itemAge
                                                        ? itemAgeList.filter((list) => list.value == item.itemAge).map((list) => list.name)
                                                        : "-"})` })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: `btn btn-guide m-0 js-open ${!item.checkGuide ? "icon-gray" : ""}`, "data-pop": "pop-guide", onClick: (e) => CheckSheetPopOpen(e, "guide", item) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBA54\uBAA8" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", disabled: sheetInfo.enabled ? true : false, className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => CheckSheetPopOpen(e, "delete", item) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) }), _jsx("td", { children: _jsxs("div", Object.assign({ className: "btn-change-area" }, { children: [_jsx("button", Object.assign({ disabled: sheetInfo.enabled ? true : false, type: "button", className: "btn btn-change-top", onClick: (e) => CheckSheetUpDown(item, "UP") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC21C\uC11C\uC704\uB85C\uBCC0\uACBD" })) })), _jsx("button", Object.assign({ disabled: sheetInfo.enabled ? true : false, type: "button", className: "btn", onClick: (e) => CheckSheetUpDown(item, "DOWN") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC21C\uC11C\uC544\uB798\uB85C\uBCC0\uACBD" })) }))] })) })] }), "sheetList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "CHECKSHEETLIST", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))) }));
}
export default CheckSheetList;
function CheckSheetPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const checksheet = useRecoilValue(checkSheetState);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    const listInfo = useRecoilValue(checkListInfo);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //
    const { popType, popReset, setPopReset, errorList, setErrorList } = props;
    //
    const itemAgeList = [
        { name: t("라벨.없음"), value: null },
        { name: "All", value: "all" },
        { name: "Condition", value: "con" },
        { name: "Degredation", value: "deg" },
    ];
    const [itemAge, setItemAge] = useState(null);
    const [groupItem, setGroupItem] = useState([]);
    const [groups, setGroups] = useState(null);
    const [checkName, setCheckName] = useState("");
    const [itemDescription, setItemDescription] = useState("");
    const [equipment, setEquipment] = useState("");
    const [equipmentName, setEquipmentName] = useState("");
    const [types, setTypes] = useState(0);
    const [sheetArr, setSheetArr] = useState([]);
    const [weight, setWeight] = useState(null);
    let item = [
        {
            score: 0,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 1,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 2,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 3,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 4,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
    ];
    let itemArr = [
        {
            score: 0,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 1,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 2,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 3,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
        {
            score: 4,
            reference: null,
            rangeFrom: null,
            rangeTo: null,
            includeFrom: types == 2 ? false : null,
            includeTo: types == 2 ? false : null,
            result: null,
            measure: null,
        },
    ];
    const [sheetArrItem, setSheetArrItem] = useState(item);
    //그룹 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checkgroups`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setGroupItem(data.body);
                if (popType == "post") {
                    setGroups(null);
                    setCheckName("");
                    setItemDescription("");
                    setEquipment("");
                    setEquipmentName("");
                    setTypes(0);
                    setWeight(null);
                    setSheetArrItem(item);
                    setItemAge(itemAgeList[0]);
                }
                else {
                    setGroups(listInfo.checkGroup);
                    setCheckName(listInfo.name);
                    setItemDescription(listInfo.description);
                    setEquipment(listInfo.instrument ? "yes" : "no");
                    setEquipmentName(listInfo.instrument);
                    setTypes(listInfo.type);
                    setWeight(listInfo.weight);
                    setItemAge(listInfo.itemAge ? itemAgeList.filter((item) => item.value == listInfo.itemAge)[0] : itemAgeList[0]);
                    if (listInfo.type !== 3) {
                        // 점수 추출
                        let score = listInfo.checkItemRef.map((sco) => sco.score);
                        // 위 없는 데이터 추출
                        let nonItem = item.filter((val) => !score.includes(val.score)).map((vlas) => vlas);
                        // 다시 배열 합치기
                        let subItem = listInfo.checkItemRef.concat(nonItem);
                        item = subItem.sort((a, b) => a.score - b.score);
                    }
                    else {
                        item = listInfo.checkItemRef;
                    }
                    setSheetArr(item);
                    setSheetArrItem(item);
                }
                if (popReset) {
                    Close("pop-g-add");
                }
            }
        }
    }, [data, popType, listInfo, popReset]);
    useEffect(() => {
        if (popType == "post") {
            if (types > 2) {
                setSheetArr(sheetArrItem.filter((_, idx) => idx == 0).map((item) => item));
            }
            else {
                setSheetArr(item);
            }
        }
        else {
            if (types == 3) {
                if (listInfo.type == types) {
                    setSheetArr(sheetArrItem);
                }
                else {
                    setSheetArr(item.filter((_, idx) => idx == 0).map((item) => item));
                }
            }
            else if (types == 2) {
                if (listInfo.type == types) {
                    setSheetArr(sheetArrItem);
                }
                else {
                    setSheetArr(itemArr);
                }
            }
            else {
                if (listInfo.type == types) {
                    setSheetArr(sheetArrItem);
                }
                else {
                    setSheetArr(itemArr);
                }
            }
        }
    }, [types]);
    // 그룹 선택
    function GroupClick(item) {
        setErrorList(errorList.filter((err) => err.field !== "checkgroupId"));
        setGroups(item);
    }
    // 항목이름
    function OnChangeCheckName(e) {
        setErrorList(errorList.filter((err) => err.field !== "name"));
        setCheckName(e.target.value);
    }
    //측정 장비
    function onClickEquipment(type) {
        setErrorList(errorList.filter((err) => err.field !== "equipment"));
        setEquipment(type);
    }
    //장비 설명
    function OnChangeEquipmentName(e) {
        setErrorList(errorList.filter((err) => err.field !== "equipmentName"));
        if (equipment == "yes") {
            setEquipmentName(e.target.value);
        }
        else {
            setEquipmentName("");
        }
    }
    function OnChangWeight(e) {
        let value = e.target.value;
        let numValue = value.replace(/[^0-9]/g, "");
        if (numValue == value) {
            setErrorList(errorList.filter((err) => err.field !== "weight"));
            setWeight(numValue);
        }
        else {
            setErrorList([{ field: "weight", msg: t("라벨.숫자만입력") }]); //올바른 가중치 값을 기입해주세요.
        }
    }
    // 점수 입력 방식
    function SheetListType(type) {
        setErrorList(errorList.filter((err) => err.field !== "type"));
        setTypes(type);
    }
    function CheckSheetSave(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!groups || !checkName || !equipment || (equipment == "yes" && !equipmentName) || !types) {
                setErrorList([
                    !groups && { field: "checkgroupId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkName && { field: "name", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !equipment && { field: "equipment", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    equipment == "yes" &&
                        !equipmentName && { field: "equipmentName", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !types && { field: "type", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
            }
            else if (types == 3 && sheetArr.filter((non) => non.measure).length <= 0) {
                setErrorList([{ field: "checkitemRef", msg: "필수항목입니다." }]);
            }
            else {
                setRecoilIsLoadingBox(true);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/checksheet/checkitem`,
                    appQuery: {
                        checkversionId: sheetInfo.checkversionId,
                        checkgroupId: groups ? groups.groupId : "",
                        name: checkName,
                        description: itemDescription,
                        weight: types !== 3 ? weight : "0",
                        type: types,
                        instrument: equipment == "no" ? null : equipmentName,
                        checkItemRef: sheetArr
                            .filter((none) => (types == 1 ? none.reference : types == 2 ? none.rangeFrom : types == 3 && none.measure))
                            .map((check) => check),
                        itemAge: types !== 3 ? itemAge.value : null,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReloadState(true);
                        Close("pop-g-add");
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-g-add", type: CONST.TYPE_NONE, divTag: t("라벨.등록완료") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        if (data.errorList.filter((err) => err.field == "popup").length > 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                        else if (data.errorList.filter((err) => err.field == "reference" || err.field == "rangeTo" || err.field == "checkitemRef").length > 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                        else {
                            setErrorList(data.errorList);
                        }
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function CheckSheetPut(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checkitem/${listInfo.checkItemId}`,
                appQuery: {
                    checkversionId: sheetInfo.checkversionId,
                    checkgroupId: groups.groupId,
                    name: checkName,
                    description: itemDescription,
                    weight: types !== 3 ? (weight == "" ? null : weight) : "0",
                    type: types,
                    instrument: equipment == "no" ? null : equipmentName,
                    checkItemRef: sheetArr
                        .filter((none) => (types == 1 ? none.reference : types == 2 ? none.rangeFrom : types == 3 && none.measure))
                        .map((check) => check),
                    itemAge: types !== 3 ? itemAge.value : null,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    Close("pop-g-add");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-g-add", type: CONST.TYPE_NONE, divTag: "수정 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    if (data.errorList.filter((err) => err.field == "popup").length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    else if (data.errorList.filter((err) => err.field == "reference" || err.field == "rangeTo" || err.field == "checkitemRef").length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    else {
                        setErrorList(data.errorList);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function Close(id) {
        if (popType == "post") {
            setGroups(null);
            setCheckName("");
            setItemDescription("");
            setEquipment("");
            setEquipmentName("");
            setTypes(0);
            setWeight(null);
            setSheetArrItem(item);
            setItemAge(itemAgeList[0]);
        }
        else {
            setGroups(listInfo.checkGroup);
            setCheckName(listInfo.name);
            setItemDescription(listInfo.description);
            setEquipment(listInfo.instrument ? "yes" : "no");
            setEquipmentName(listInfo.instrument);
            setTypes(listInfo.type);
            setWeight(listInfo.weight);
            setItemAge(listInfo.itemAge ? itemAgeList.filter((item) => item.value == listInfo.itemAge)[0] : itemAgeList[0]);
            if (listInfo.type !== 3) {
                // 점수 추출
                let score = listInfo.checkItemRef.map((sco) => sco.score);
                // 위 없는 데이터 추출
                let nonItem = item.filter((val) => !score.includes(val.score)).map((vlas) => vlas);
                // 다시 배열 합치기
                let subItem = listInfo.checkItemRef.concat(nonItem);
                item = subItem.sort((a, b) => a.score - b.score);
            }
            else {
                item = listInfo.checkItemRef;
            }
            setSheetArr(item);
            setSheetArrItem(item);
        }
        CUTIL.jsclose_Popup(id);
        setPopReset(false);
    }
    return (_jsxs(_Fragment, { children: [groupItem && (_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: checksheet.sheetType }), _jsx("li", { children: checksheet.spgName }), _jsx("li", { children: sheetInfo.checkSubTypeName })] })), _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1" }, { children: [_jsx("div", Object.assign({ className: "tbl__top brd-bottom-1 pb-26 mb-24" }, { children: _jsx("h2", { children: t("라벨.점검항목정보") }) })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.그룹") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select ${errorList.filter((err) => err.field === "checkgroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => !sheetInfo.enabled && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: groups ? groups.groupName : !popReset && t("라벨.그룹을선택해주세요") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: groupItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => GroupClick(item) }, { children: item.groupName }), "group_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkgroupId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.항목이름") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp12", placeholder: t("라벨.텍스트입력"), className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, readOnly: sheetInfo.enabled ? true : false, value: checkName, onChange: (e) => OnChangeCheckName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: t("라벨.항목설명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", placeholder: t("라벨.필요시텍스트를입력"), readOnly: sheetInfo.enabled ? true : false, value: itemDescription, onChange: (e) => setItemDescription(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.측정장비") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "radioBox left" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd1" }, { children: [_jsx("input", { type: "radio", id: "rd1", name: "rd", className: `${errorList.filter((err) => err.field === "equipment").length > 0 ? " input-error" : ""}`, disabled: sheetInfo.enabled ? true : false, checked: equipment == "yes", onChange: (e) => onClickEquipment("yes") }), t("라벨.필요")] })), _jsxs("label", Object.assign({ htmlFor: "rd2" }, { children: [_jsx("input", { type: "radio", id: "rd2", name: "rd", className: `${errorList.filter((err) => err.field === "equipment").length > 0 ? " input-error" : ""}`, disabled: sheetInfo.enabled ? true : false, checked: equipment == "no", onChange: (e) => onClickEquipment("no") }), t("라벨.불필요")] }))] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "equipment").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${equipment == "yes" ? "star" : ""}` }, { children: t("라벨.측정장비명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp3", placeholder: equipment == "yes" ? t("라벨.예시열화상카메라") : "", className: `${equipment == "yes" && errorList.filter((err) => err.field === "equipmentName").length > 0
                                                                    ? " input-error"
                                                                    : ""}`, value: equipmentName ? equipmentName : "", onChange: (e) => OnChangeEquipmentName(e), readOnly: equipment == "no" || sheetInfo.enabled ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "equipmentName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점수입력방식") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "radioBox left" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd11" }, { children: [_jsx("input", { type: "radio", id: "rd11", disabled: sheetInfo.enabled ? true : false, className: `${errorList.filter((err) => err.field === "type").length > 0 ? " input-error" : ""}`, name: "rd11", checked: types == 1 ? true : false, onChange: (e) => SheetListType(1) }), t("라벨.점수선택")] })), _jsxs("label", Object.assign({ htmlFor: "rd12" }, { children: [_jsx("input", { type: "radio", id: "rd12", disabled: sheetInfo.enabled ? true : false, className: `${errorList.filter((err) => err.field === "type").length > 0 ? " input-error" : ""}`, name: "rd12", checked: types == 2 ? true : false, onChange: (e) => SheetListType(2) }), t("라벨.측정값입력")] })), _jsxs("label", Object.assign({ htmlFor: "rd13" }, { children: [_jsx("input", { type: "radio", id: "rd13", disabled: sheetInfo.enabled ? true : false, className: `${errorList.filter((err) => err.field === "type").length > 0 ? " input-error" : ""}`, name: "rd1", checked: types == 3 ? true : false, onChange: (e) => SheetListType(3) }), _jsxs("p", Object.assign({ className: "m-mt-3" }, { children: [t("라벨.측정값기록"), _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", t("라벨.점수없음"), ")"] }))] }))] }))] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "type").map((err) => err.msg) }))] }))] })] }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-2-1" }, { children: [_jsx("div", Object.assign({ className: "tbl__top brd-bottom-1 pb-26 mb-24" }, { children: _jsx("h2", { children: t("라벨.평가기준") }) })), types !== 3 && (_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", Object.assign({ className: "font-14 star" }, { children: t("라벨.가중치") })) })), _jsxs("div", Object.assign({ className: "select w110", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: itemAge && itemAge.name })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: itemAgeList.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => setItemAge(list) }, { children: list.name }), "itemAge_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__area ml-7 w-auto" }, { children: [_jsx("input", { type: "text", id: "inp1", className: `${errorList.filter((err) => err.field === "weight").length > 0 ? " input-error" : ""}`, readOnly: sheetInfo.enabled ? true : false, placeholder: t("라벨.1이상정수입력"), value: weight ? weight : "", onChange: (e) => OnChangWeight(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "weight").map((err) => err.msg) }))] }))] })) })) }))), _jsx("div", Object.assign({ className: "tbl-list" }, { children: types == 1 ? (_jsx(CheckType1, { enabled: sheetInfo.enabled, sheetArr: sheetArr, setSheetArr: setSheetArr, errorList: errorList, setErrorList: setErrorList })) : types == 2 ? (_jsx(CheckType2, { enabled: sheetInfo.enabled, sheetArr: sheetArr, setSheetArr: setSheetArr, errorList: errorList, setErrorList: setErrorList })) : (types == 3 && (_jsx(CheckType3, { enabled: sheetInfo.enabled, sheetArr: sheetArr, setSheetArr: setSheetArr, errorList: errorList, setErrorList: setErrorList }))) }))] }))] }))] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-g-add") }, { children: _jsx("span", { children: t("라벨.취소") }) }))), sheetInfo.enabled ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => CUTIL.jsclose_Popup("pop-g-add") }, { children: _jsx("span", { children: t("라벨.확인") }) }))) : popType == "post" ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => CheckSheetSave(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => CheckSheetPut(e) }, { children: _jsx("span", { children: t("라벨.수정") }) })))] }))] }));
}
function CheckType1(props) {
    const t = useTrans();
    const { sheetArr, setSheetArr, enabled, errorList, setErrorList } = props;
    function OnCanaheSheet(e, idx) {
        setErrorList(errorList.filter((err) => err.field !== "checkitemRef"));
        setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { reference: e.target.value }) : smenu)));
    }
    function OnCanaheSheetResult(e, idx) {
        let text = e.target.value;
        setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { result: text.length <= 8 ? text : "" }) : smenu)));
    }
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ summary: "\uC810\uC218,\uD3C9\uAC00 \uAE30\uC900 (\uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBCF4\uC5EC\uC9D0),\uC810\uAC80\uACB0\uACFC\uD45C\uC2DC(\uCD5C\uB300 8\uC790) \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "50px" } }), _jsx("col", { style: { width: "400px" } }), _jsx("col", { style: { width: "110px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.점수") })), _jsxs("th", Object.assign({ scope: "col", className: "txt-center" }, { children: [t("라벨.평가기준"), " (", t("라벨.사용자에게보여짐"), ")"] })), _jsxs("th", Object.assign({ scope: "col", className: "txt-center" }, { children: [t("라벨.점검결과표시"), "(", t("라벨.최대8자"), ")"] }))] }) }), _jsx("tbody", { children: sheetArr.map((item, idx) => (_jsxs("tr", { children: [_jsxs("td", Object.assign({ className: "txt-center txt-top pt-20" }, { children: [item.score, " ", t("라벨.점")] }), "evaluation_" + idx.toString()), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: `h74 `, readOnly: enabled ? true : false, value: CUTIL.isnull(item.reference) ? "" : item.reference, onChange: (e) => OnCanaheSheet(e, idx) }) })) })), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", readOnly: enabled ? true : false, placeholder: t("라벨.예시양호"), value: CUTIL.isnull(item.result) ? "" : item.result, onChange: (e) => OnCanaheSheetResult(e, idx) }) })) }))] }, "type_1" + idx.toString()))) })] })) }));
}
function CheckType2(props) {
    const t = useTrans();
    const { sheetArr, setSheetArr, enabled, errorList, setErrorList } = props;
    function OnCanaheSheetRangeTo(e, idx) {
        setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { rangeTo: e.target.value }) : smenu)));
    }
    function OnCanaheSheetCheckedTo(checked, idx) {
        if (checked) {
            setSheetArr(sheetArr.map((smenu) => smenu.score === idx ? Object.assign(Object.assign({}, smenu), { includeTo: checked, includeFrom: !checked }) : smenu));
        }
        else {
            setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { includeTo: checked, includeFrom: checked }) : smenu)));
        }
    }
    function OnCanaheSheetCheckedFrom(checked, idx) {
        if (checked) {
            setSheetArr(sheetArr.map((smenu) => smenu.score === idx ? Object.assign(Object.assign({}, smenu), { includeFrom: checked, includeTo: !checked }) : smenu));
        }
        else {
            setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { includeFrom: checked, includeTo: checked }) : smenu)));
        }
    }
    function OnCanaheSheetRangeFrom(e, idx) {
        setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { rangeFrom: e.target.value }) : smenu)));
    }
    function OnCanaheSheet(e, idx) {
        setErrorList(errorList.filter((err) => err.field !== "checkitemRef"));
        setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { reference: e.target.value }) : smenu)));
    }
    function OnCanaheSheetResult(e, idx) {
        let text = e.target.value;
        if (text.length < 8) {
            setSheetArr(sheetArr.map((smenu) => (smenu.score === idx ? Object.assign(Object.assign({}, smenu), { result: text }) : smenu)));
        }
    }
    // const checkError = (min, max, text) => {
    //   if (CUTIL.isnull(min) && CUTIL.isnull(max) && CUTIL.isnull(text)) {
    //     return false;
    //   }
    //   // 하나라도 null이면 false 반환
    //   if (CUTIL.isnull(min) || CUTIL.isnull(max) || CUTIL.isnull(text)) {
    //     return true;
    //   }
    //   // 모두 null이 아닌 경우는 true 반환
    //   return true;
    // };
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ summary: "\uC810\uC218,\uC810\uC218\uAE30\uC900,\uD3C9\uAC00 \uAE30\uC900 (\uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBCF4\uC5EC\uC9D0),\uC810\uAC80\uACB0\uACFC\uD45C\uC2DC(\uCD5C\uB300 8\uC790) \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "70px" } }), _jsx("col", { style: { width: "230px" } }), _jsx("col", { style: { width: "340px" } }), _jsx("col", { style: { width: "140px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.점수") })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.점수기준") })), _jsxs("th", Object.assign({ scope: "col", className: "txt-center" }, { children: [t("라벨.평가기준"), " (", t("라벨.사용자에게보여짐"), ")"] })), _jsxs("th", Object.assign({ scope: "col", className: "txt-center" }, { children: [t("라벨.점검결과표시"), "(", t("라벨.최대8자"), ")"] }))] }) }), _jsx("tbody", { children: sheetArr.map((item, idx) => (_jsxs("tr", { children: [_jsxs("td", Object.assign({ className: "txt-center txt-top pt-20" }, { children: [item.score, " ", t("라벨.점")] }), "evaluation_" + idx.toString()), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsxs("ul", Object.assign({ className: "input__area" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "t2" }, { children: t("라벨.최소값") })), _jsx("input", { type: "text", readOnly: enabled ? true : false, className: "w84 ml-16 mr-14", id: "t2", value: CUTIL.isnull(item.rangeFrom) ? "" : item.rangeFrom, onChange: (e) => OnCanaheSheetRangeFrom(e, idx) }), _jsxs("div", Object.assign({ className: "checkBox" }, { children: [_jsx("input", { type: "checkbox", id: "st_2" + idx, disabled: enabled ? true : false, checked: item.includeFrom ? true : false, onChange: (e) => OnCanaheSheetCheckedFrom(!item.includeFrom, idx) }), _jsx("label", Object.assign({ htmlFor: "st_2" + idx }, { children: t("라벨.포함") }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "t1" }, { children: t("라벨.최대값") })), _jsx("input", { type: "text", readOnly: enabled ? true : false, className: "w84 ml-16 mr-14", id: "t1", value: CUTIL.isnull(item.rangeTo) ? "" : item.rangeTo, onChange: (e) => OnCanaheSheetRangeTo(e, idx) }), _jsxs("div", Object.assign({ className: "checkBox" }, { children: [_jsx("input", { type: "checkbox", id: "st_1" + idx, disabled: enabled ? true : false, checked: item.includeTo ? true : false, onChange: (e) => OnCanaheSheetCheckedTo(!item.includeTo, idx) }), _jsx("label", Object.assign({ htmlFor: "st_1" + idx }, { children: t("라벨.포함") }))] }))] })] })) })), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: `h74 ${idx == 0 && errorList.filter((err) => err.field === "checkitemRef").length > 0
                                            ? " input-error"
                                            : ""}`, readOnly: enabled ? true : false, value: CUTIL.isnull(item.reference) ? "" : item.reference, onChange: (e) => OnCanaheSheet(e, idx) }) })) })), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", readOnly: enabled ? true : false, placeholder: t("라벨.예시양호"), value: CUTIL.isnull(item.result) ? "" : item.result, onChange: (e) => OnCanaheSheetResult(e, idx) }) })) }))] }, "type_1" + idx.toString()))) })] })) }));
}
// 3번 항목
function CheckType3(props) {
    const t = useTrans();
    const { sheetArr, setSheetArr, errorList, setErrorList, enabled } = props;
    function OnCanaheSheet(e, item) {
        setErrorList(errorList.filter((err) => err.field !== "checkitemRef"));
        setSheetArr(sheetArr.map((smenu) => (smenu === item ? Object.assign(Object.assign({}, smenu), { measure: e.target.value }) : smenu)));
    }
    function OnCanaheSheetRefer(e, item) {
        setSheetArr(sheetArr.map((smenu) => (smenu === item ? Object.assign(Object.assign({}, smenu), { reference: e.target.value }) : smenu)));
    }
    // 측정명 삭제
    function LsitDelete(item) {
        if (sheetArr.length > 1) {
            setSheetArr(sheetArr.filter((ditem) => ditem !== item));
        }
    }
    // 측정명 추가
    function ListAdd(e) {
        const items = {
            score: sheetArr.length,
            reference: "",
            result: "",
            rangeFrom: null,
            rangeTo: null,
            measure: "",
        };
        if (sheetArr.length < 10) {
            setSheetArr([...sheetArr, items]);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ summary: "\uCE21\uC815 \uBA85,\uC124\uBA85 (\uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBCF4\uC5EC\uC9D0), \uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD3C9\uAC00 \uAE30\uC900 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "150px" } }), _jsx("col", { style: {} }), _jsx("col", { style: { width: "70px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.측정명") })), _jsxs("th", Object.assign({ scope: "col", className: "txt-center" }, { children: [t("라벨.설명"), " (", t("라벨.사용자에게보여짐"), ")"] })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.삭제") }))] }) }), _jsxs("tbody", { children: [sheetArr.map((item, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: `${idx == 0 && errorList.filter((err) => err.field === "checkitemRef").length > 0
                                                ? " input-error"
                                                : ""}`, readOnly: enabled ? true : false, placeholder: t("라벨.측정명"), value: CUTIL.isnull(item.measure) ? "" : item.measure, onChange: (e) => OnCanaheSheet(e, item) }) })) })), _jsx("td", Object.assign({ className: "txt-center" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "", placeholder: t("라벨.설명을작성해주세요"), readOnly: enabled ? true : false, value: CUTIL.isnull(item.reference) ? "" : item.reference, onChange: (e) => OnCanaheSheetRefer(e, item) }) })) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", disabled: enabled ? true : false, className: "btn btn-delete-gr js-open", "data-pop": "pop-delete1", onClick: (e) => LsitDelete(item) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, "type3_" + idx.toString()))), sheetArr.length < 10 && (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: 3, className: "bg-no" }, { children: _jsx("button", Object.assign({ type: "button", disabled: enabled ? true : false, className: "btn-add-wide", onClick: (e) => ListAdd(e) }, { children: _jsx("span", { children: t("라벨.측정명추가") }) })) })) }))] })] })) }));
}
function GuidePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const checksheet = useRecoilValue(checkSheetState);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    const listInfo = useRecoilValue(checkListInfo);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //props
    const { popReset, setPopReset, errorList, setErrorList } = props;
    const [guide1, setGuide1] = useState(null);
    const [file1, setFile1] = useState([]);
    const [guide2, setGuide2] = useState(null);
    const [file2, setFile2] = useState([]);
    const [guide3, setGuide3] = useState(null);
    const [file3, setFile3] = useState([]);
    const [guideView, setGuideView] = useState([]);
    const lastNum = 10;
    let appPath = `?checkitemId=${listInfo.checkItemId}`;
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checkitem/checkguides${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadState,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (data.body.length <= 0) {
                    let guideVla1 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 1,
                    };
                    setGuide1(guideVla1);
                    let guideVla2 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 2,
                    };
                    setGuide2(guideVla2);
                    let guideVla3 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 2,
                    };
                    setGuide3(guideVla3);
                    setGuideView([]);
                    setFile1([]);
                    setFile2([]);
                    setFile3([]);
                }
                else {
                    let guideVla1 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 1,
                        files: [],
                    };
                    let guideVla2 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 2,
                        files: [],
                    };
                    let guideVla3 = {
                        title: "",
                        content: "",
                        checkguideId: -1,
                        sort: 3,
                        files: [],
                    };
                    data.body.filter((_, idx) => idx == 0).map((item) => (guideVla1 = item));
                    setGuide1(guideVla1);
                    setFile1(guideVla1.files);
                    data.body.filter((_, idx) => idx == 1).map((item) => (guideVla2 = item));
                    setGuide2(guideVla2);
                    setFile2(guideVla2.files);
                    data.body.filter((_, idx) => idx == 2).map((item) => (guideVla3 = item));
                    setGuide3(guideVla3);
                    setFile3(guideVla3.files);
                    setGuideView(data.body);
                }
                if (popReset) {
                    setGuide1(null);
                    setFile1(data.body.filter((_, idx) => idx == 0).map((item) => item.files));
                    setGuide2(null);
                    setFile2(data.body.filter((_, idx) => idx == 1).map((item) => item.files));
                    setGuide3(null);
                    setFile3(data.body.filter((_, idx) => idx == 2).map((item) => item.files));
                    CUTIL.jsclose_Popup("pop-guide");
                    setPopReset(false);
                }
            }
        }
    }, [data, listInfo, popReset]);
    /* function GuideAdd(e) {
      if (guide.length < 3) {
        let guideVla = {
          title: "",
          content: "",
          checkguideId: -1,
          sort: guide.length + 1,
  
        }
        setGuide([...guide, guideVla])
      }
    } */
    //  1번
    function OnCanahTitle1(e) {
        setErrorList(errorList.filter((err) => err.field !== "guide1"));
        setGuide1(Object.assign(Object.assign({}, guide1), { title: e.target.value }));
    }
    function OnCanahContent1(e) {
        setGuide1(Object.assign(Object.assign({}, guide1), { content: e.target.value }));
    }
    // 첨부파일 저장
    function saveFileImage1(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file1];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile1(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete1(item, index) {
        if (item.fileId) {
            GuidImg(item.fileId);
        }
        else {
            setFile1(file1.filter((_, idx) => idx !== index));
        }
    }
    // 2번 레이아웃
    function OnCanahTitle2(e) {
        setGuide2(Object.assign(Object.assign({}, guide2), { title: e.target.value }));
    }
    function OnCanahContent2(e) {
        setGuide2(Object.assign(Object.assign({}, guide2), { content: e.target.value }));
    }
    // 첨부파일 저장
    function saveFileImage2(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file2];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile2(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete2(item, index) {
        if (item.fileId) {
            GuidImg(item.fileId);
        }
        else {
            setFile2(file2.filter((_, idx) => idx !== index));
        }
    }
    // 3번 레이아웃
    function OnCanahTitle3(e) {
        setGuide3(Object.assign(Object.assign({}, guide3), { title: e.target.value }));
    }
    function OnCanahContent3(e) {
        setGuide3(Object.assign(Object.assign({}, guide3), { content: e.target.value }));
    }
    // 첨부파일 저장
    function saveFileImage3(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file3];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile3(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete3(item, index) {
        if (item.fileId) {
            GuidImg(item.fileId);
        }
        else {
            setFile3(file3.filter((_, idx) => idx !== index));
        }
    }
    function GuideSaves(e) {
        if (!guide1.title) {
            setErrorList([!guide1.title && { field: "guide1", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
        }
        else {
            const dataObj = {
                title: guide1.title,
                content: guide1.content,
            };
            setRecoilIsLoadingBox(true);
            if (guide1.checkguideId > 0) {
                GuidEidt1(dataObj, guide1.checkguideId);
            }
            else {
                GuideSave1(dataObj);
            }
        }
    }
    // 1번 등록
    function GuideSave1(dataObj) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideDtoIn", blob);
            file1.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/${listInfo.checkItemId}/checkguide`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!guide2.title) {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "등록이 되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                        //
                        if (!guide3.title) {
                            setReloadState(true);
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "등록이 되었습니다." }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setReloadState(false);
                            setRecoilIsLoadingBox(false);
                        }
                        else {
                            const dataObj = {
                                title: guide3.title,
                                content: guide3.content,
                            };
                            if (guide3.checkguideId > 0) {
                                GuidEidt3(dataObj, guide3.checkguideId);
                            }
                            else {
                                GuideSave3(dataObj);
                            }
                        }
                    }
                    else {
                        const dataObj = {
                            title: guide2.title,
                            content: guide2.content,
                        };
                        if (guide2.checkguideId > 0) {
                            GuidEidt2(dataObj, guide2.checkguideId);
                        }
                        else {
                            GuideSave2(dataObj);
                        }
                    }
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 1번 수정
    function GuidEidt1(dataObj, checkguideId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideUpdateDtoIn", blob);
            file1.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/checkguide/${checkguideId}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!guide2.title) {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "수정 되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                        //
                        if (!guide3.title) {
                        }
                        else {
                            const dataObj = {
                                title: guide3.title,
                                content: guide3.content,
                            };
                            if (guide3.checkguideId > 0) {
                                GuidEidt3(dataObj, guide3.checkguideId);
                            }
                            else {
                                GuideSave3(dataObj);
                            }
                        }
                    }
                    else {
                        const dataObj = {
                            title: guide2.title,
                            content: guide2.content,
                        };
                        if (guide2.checkguideId > 0) {
                            GuidEidt2(dataObj, guide2.checkguideId);
                        }
                        else {
                            GuideSave2(dataObj);
                        }
                    }
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 2번 등록
    function GuideSave2(dataObj) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideDtoIn", blob);
            file2.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/${listInfo.checkItemId}/checkguide`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!guide3.title) {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "등록이 되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        const dataObj = {
                            title: guide3.title,
                            content: guide3.content,
                        };
                        if (guide3.checkguideId > 0) {
                            GuidEidt3(dataObj, guide3.checkguideId);
                        }
                        else {
                            GuideSave3(dataObj);
                        }
                    }
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 2번 수정
    function GuidEidt2(dataObj, checkguideId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideUpdateDtoIn", blob);
            file2.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/checkguide/${checkguideId}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!guide3.title) {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "수정 되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        const dataObj = {
                            title: guide3.title,
                            content: guide3.content,
                        };
                        if (guide3.checkguideId > 0) {
                            GuidEidt3(dataObj, guide3.checkguideId);
                        }
                        else {
                            GuideSave3(dataObj);
                        }
                    }
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 3번 등록
    function GuideSave3(dataObj) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideDtoIn", blob);
            file3.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/${listInfo.checkItemId}/checkguide`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "등록이 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 1번 수정
    function GuidEidt3(dataObj, checkguideId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(dataObj)], {
                type: "application/json",
            });
            formData.append("checkGuideUpdateDtoIn", blob);
            file3.map((files) => formData.append("files", files));
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/checksheet/checkitem/checkguide/${checkguideId}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: "수정 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 가이드 삭제
    function GuidDel(checkguideId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/checksheet/checkitem/checkguide/${checkguideId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: data.body }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-guide");
                    setReloadState(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 가이드 이미지 삭제
    function GuidImg(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/file/${fileId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-guide", type: CONST.TYPE_ERROR, divTag: data.body }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-guide");
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    function Close(id) {
        setPopReset(true);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: checksheet.sheetType }), _jsx("li", { children: checksheet.spgName }), _jsx("li", { children: sheetInfo.checkSubTypeName }), _jsx("li", { children: listInfo.name })] })), _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1" }, { children: [_jsx("div", Object.assign({ className: "tbl__top brd-bottom-1 pb-12 mb-4" }, { children: _jsx("h2", { children: t("라벨.점검가이드") }) })), _jsxs("ul", Object.assign({ className: "scrollH h500" }, { children: [guide1 && (_jsx(Guide1, { guide1: guide1, OnCanahTitle1: OnCanahTitle1, saveFileImage1: saveFileImage1, file1: file1, onClickAttachFileDelete1: onClickAttachFileDelete1, OnCanahContent1: OnCanahContent1, GuidDel: GuidDel, enabled: sheetInfo.enabled, errorList: errorList })), guide2 && (_jsx(Guide2, { guide2: guide2, OnCanahTitle2: OnCanahTitle2, saveFileImage2: saveFileImage2, file2: file2, onClickAttachFileDelete2: onClickAttachFileDelete2, OnCanahContent2: OnCanahContent2, GuidDel: GuidDel, enabled: sheetInfo.enabled })), guide3 && (_jsx(Guide3, { guide3: guide3, OnCanahTitle3: OnCanahTitle3, saveFileImage3: saveFileImage3, file3: file3, onClickAttachFileDelete3: onClickAttachFileDelete3, OnCanahContent3: OnCanahContent3, GuidDel: GuidDel, enabled: sheetInfo.enabled }))] }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1-3" }, { children: [_jsx("div", Object.assign({ className: "tbl__top brd-bottom-1 pb-26 mb-24" }, { children: _jsx("h2", { children: t("라벨.미리보기") }) })), _jsx("div", Object.assign({ className: "scrollH h482" }, { children: guideView.length > 0 &&
                                            guideView.map((list, idx) => (_jsx("ul", Object.assign({ className: "imgbox-area brd-bottom-1 pb-26 mb-24" }, { children: list.files.length <= 0 ? (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit mb-12" }, { children: list.title })), _jsx("p", Object.assign({ className: "txt mt-0" }, { children: list.content }))] })) : (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit mb-8" }, { children: list.title })), _jsxs("p", Object.assign({ className: "txt-right mb-12" }, { children: [list.files.length, "/10"] })), _jsx("ul", Object.assign({ className: `img-area w743 ${list.files.map((img) => img.name.split(".")[1] == "png" ||
                                                                img.name.split(".")[1] == "jpeg" ||
                                                                img.name.split(".")[1] == "jpg"
                                                                ? ""
                                                                : "video")}` }, { children: list.files.map((img, i) => (_jsx("li", { children: img.name.split(".")[1] == "png" ||
                                                                    img.name.split(".")[1] == "jpeg" ||
                                                                    img.name.split(".")[1] == "jpg" ? (_jsx("img", { src: img.url, alt: img.name }, "img_" + idx.toString())) : (_jsx("video", { src: img.url, controls: true }, "movi_" + idx.toString())) }, "files" + i.toString()))) })), _jsx("p", Object.assign({ className: "txt mt-16" }, { children: list.content }))] })) }), "view_" + idx.toString()))) }))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!sheetInfo.enabled ? (_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-guide") }, { children: _jsx("span", { children: t("라벨.취소") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-guide") }, { children: _jsx("span", { children: t("라벨.확인") }) }))), !sheetInfo.enabled && (_jsx("button", Object.assign({ type: "button", onClick: (e) => GuideSaves(e) }, { children: _jsx("span", { children: t("라벨.저장") }) })))] }))] }));
}
// 1번 화면
function Guide1(props) {
    const t = useTrans();
    const { guide1, OnCanahTitle1, saveFileImage1, file1, onClickAttachFileDelete1, OnCanahContent1, GuidDel, enabled, errorList, } = props;
    return (_jsx(_Fragment, { children: _jsxs("li", { children: [_jsx("div", Object.assign({ className: "tbl__top mb-4" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr w32 h32", onClick: (e) => GuidDel(guide1.checkguideId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))) })) })), _jsxs("ul", Object.assign({ className: "form__input mt-0 mb-28 pb-24 brd-bottom-1" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제목") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp1", placeholder: t("라벨.가이드제목을입력하세요"), className: `${errorList.filter((err) => err.field === "guide1").length > 0 ? " input-error" : ""}`, disabled: enabled ? true : false, value: guide1.title, onChange: (e) => OnCanahTitle1(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "guide1").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.파일을첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file1" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file1", accept: "video/*, image/*", disabled: enabled ? true : false, multiple: true, onChange: (e) => saveFileImage1(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.500MB이하이미지동영상") })), file1.map((img, i) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete1(img, i) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })))] }) }), "imgs_1" + i.toString())))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.본문") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", disabled: enabled ? true : false, placeholder: t("라벨.텍스트입력"), value: guide1.content, onChange: (e) => OnCanahContent1(e), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, OnCanahContent1) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [CUTIL.isnull(guide1.content) ? "0" : guide1.content.length, " / 400"] }))] }))] })] }))] }) }));
}
// 2번 화면
function Guide2(props) {
    const t = useTrans();
    const { guide2, OnCanahTitle2, saveFileImage2, file2, onClickAttachFileDelete2, OnCanahContent2, GuidDel, enabled } = props;
    return (_jsx(_Fragment, { children: _jsxs("li", { children: [_jsx("div", Object.assign({ className: "tbl__top mb-4" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr w32 h32", onClick: (e) => GuidDel(guide2.checkguideId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))) })) })), _jsxs("ul", Object.assign({ className: "form__input mt-0 mb-28 pb-24 brd-bottom-1" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제목") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp1", placeholder: t("라벨.가이드제목을입력하세요"), disabled: enabled ? true : false, value: guide2.title, onChange: (e) => OnCanahTitle2(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.파일을첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file2" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file2", accept: "video/*, image/*", disabled: enabled ? true : false, multiple: true, onChange: (e) => saveFileImage2(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.500MB이하이미지동영상") })), file2.map((img, i) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete2(img, i) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })))] }) }), "imgs2_" + i.toString())))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.본문") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", disabled: enabled ? true : false, placeholder: t("라벨.텍스트입력"), value: guide2.content, onChange: (e) => OnCanahContent2(e), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, OnCanahContent2) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [CUTIL.isnull(guide2.content) ? "0" : guide2.content.length, " / 400"] }))] }))] })] }))] }) }));
}
// 3번 화면
function Guide3(props) {
    const t = useTrans();
    const { guide3, OnCanahTitle3, saveFileImage3, file3, onClickAttachFileDelete3, OnCanahContent3, GuidDel, enabled } = props;
    return (_jsx(_Fragment, { children: _jsxs("li", { children: [_jsx("div", Object.assign({ className: "tbl__top mb-4" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr w32 h32", onClick: (e) => GuidDel(guide3.checkguideId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))) })) })), _jsxs("ul", Object.assign({ className: "form__input mt-0 mb-28 pb-24 brd-bottom-1" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제목") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp1", placeholder: t("라벨.가이드제목을입력하세요"), disabled: enabled ? true : false, value: guide3.title, onChange: (e) => OnCanahTitle3(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.파일을첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file3" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file3", accept: "video/*, image/*", disabled: enabled ? true : false, multiple: true, onChange: (e) => saveFileImage3(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.500MB이하이미지동영상") })), file3.map((img, i) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), !enabled && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete3(img, i) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })))] }) }), "imgs_3" + i.toString())))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.본문") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", disabled: enabled ? true : false, placeholder: t("라벨.텍스트입력"), value: guide3.content, onChange: (e) => OnCanahContent3(e), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, OnCanahContent3) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [CUTIL.isnull(guide3.content) ? "0" : guide3.content.length, " / 400"] }))] }))] })] }))] }) }));
}
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadtate = useSetRecoilState(reLoadState);
    const listInfo = useRecoilValue(checkListInfo);
    const [alert, setAlert] = useRecoilState(alertState);
    function SheetDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/checksheet/checkitem/${listInfo.checkItemId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadtate(true);
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_NONE, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadtate(false);
                }
                else {
                    // need error handle
                    setReloadtate(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete");
                    setReloadtate(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.진단점검항목을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SheetDelete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function VerDeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadState = useSetRecoilState(reLoadState);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const [alert, setAlert] = useRecoilState(alertState);
    const { WorkModes } = props;
    //버젼 삭제
    function SheetDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/checksheet/checktype/checksubtype/checkversion/${sheetInfo.checkversionId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    CUTIL.jsclose_Popup("pop-check-close");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-check-close", type: CONST.TYPE_NONE, divTag: sheetInfo.count > 1 ? data.body : t("라벨.체크시트와상세유형항목이삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    WorkModes("VIEW");
                    setReloadState(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsclose_Popup("pop-check-close");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.최신버전체크시트삭제", [sheetInfo.versionNo]) }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SheetDelete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
